// import { selectProductsInitWaitingMessage } from './../_selectors/product.selectors';
// RxJS
import { Observable, of } from "rxjs";
import 'rxjs/add/observable/of';
import { catchError, delay, distinctUntilChanged, finalize } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
import { PhoneCallLogService } from "../_services/phone-call-log.service";

export class PhoneCallLogsDataSource extends BaseDataSource {
  constructor(private phoneCallLogService:PhoneCallLogService) {
    super();
    // this.loading$ = this.store.pipe(
    //   select(selectPhoneCallLogsPageLoading)
    // );

    // this.isPreloadTextViewed$ = this.store.pipe(
    //   select(selectPhoneCallLogsShowInitWaitingMessage)
    // );

    // this.store.pipe(
    //   select(selectPhoneCallLogsInStore)
    // ).subscribe((response: QueryResultsModel) => {
    //   this.paginatorTotalSubject.next(response.totalCount);
    //   this.entitySubject.next(response.items);
    // });
  }
  loadPageRequesed(page) {
    this.loading$ = Observable.of(true);
    this.isPreloadTextViewed$ = Observable.of(true);
    this.phoneCallLogService.findPhoneCallLogs(page).pipe(
      catchError(() => of([])),
      finalize(() => this.isPreloadTextViewed$ = this.loading$ = Observable.of(false),)
    ).subscribe(response => {
      this.loading$ = Observable.of(false);
      this.isPreloadTextViewed$ = Observable.of(false);
      const data = response['data'];
      this.paginatorTotalSubject.next(data.totalElements);
      this.entitySubject.next(data['content']);
    })
  }
}
